import "./Features.scss";

const features = [
  {
    icon: "◎",
    title: "Surrounding Influence",
    copy: "Conquer connected buildings around a target to weaken it. The more influence you build nearby, the fewer warriors you may need to capture a powerful building.",
    color: "#3E6F58"
  },
  {
    icon: "✦",
    title: "Resource Abilities",
    copy: "Every conquered building gives you a resource with a special ability. Use resources at the right moment to strengthen your turn and open new tactical options.",
    color: "#CC7722"
  },
  {
    icon: "⇄",
    title: "Variable Setup",
    copy: "Buildings and resources are placed differently each game, so players must adapt to a new map instead of following the same strategy every time.",
    color: "#6D3B79"
  },
  {
    icon: "2–4",
    title: "Balanced at Every Player Count",
    copy: "Kotam is designed to stay competitive with 2, 3, or 4 players. In lower-player games, Peace Flags shape the board to keep tension high and prevent the map from feeling too open.",
    color: "#375E97"
  },
  {
    icon: "⚑",
    title: "Dual-Use Flags",
    copy: "Player flags serve more than one purpose: use them as banners to mark conquered buildings, then turn them into crowns when needed for scoring and game-state clarity.",
    color: "#9B2D30"
  },
  {
    icon: "▣",
    title: "Table-Readable Components",
    copy: "Flags show control. Buildings show targets. Resources show rewards. Each component helps the board tell the story of a growing conquest.",
    color: "#D7A84F"
  }
];

export default function Features() {
  return (
    <section className="features section" id="features">
      <div className="features__layout">
        <div>
          <span className="section-eyebrow">What Makes Kotam Unique</span>
          <h2 className="section-title">A Realm That Changes With Every Conquest.</h2>
          <p className="section-copy">
            In Kotam: Conquest, every building you capture does more than give you points. Your flags create influence, your resources unlock stronger turns, and the changing setup gives each game a new path to victory.
          </p>
          <p className="features__highlight">
            The core turn is simple, but every conquest changes what becomes possible next.
          </p>
        </div>

        <div className="features__grid">
          {features.map((feature) => (
            <div className="features__item card" key={feature.title}>
              <span
                className="features__icon"
                style={{ backgroundColor: feature.color }}
                aria-hidden="true"
              >
                {feature.icon}
              </span>
              <div>
                <h3>{feature.title}</h3>
                <p>{feature.copy}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
